var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m391 0h-225c-24.853 0-45 20.147-45 45v422c0 24.853 20.147 45 45 45h300c24.853 0 45-20.147 45-45v-347z",
    fill: "#e4f2f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m391 0h-75v512h150c24.853 0 45-20.147 45-45v-347z",
    fill: "#bde0f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m391 0v105c0 8.284 6.716 15 15 15h105z",
    fill: "#77bee2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5f5f82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426 302h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 212h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 392h-220c-8.284 0-15-6.716-15-15s6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m441 287c0-8.284-6.716-15-15-15h-110v30h110c8.284 0 15-6.716 15-15z",
    fill: "#3c3c55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m441 197c0-8.284-6.716-15-15-15h-110v30h110c8.284 0 15-6.716 15-15z",
    fill: "#3c3c55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m426 392c8.284 0 15-6.716 15-15s-6.716-15-15-15h-110v30z",
    fill: "#3c3c55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m136 512c-74.439 0-135-60.561-135-135s60.561-135 135-135 135 60.561 135 135-60.561 135-135 135z",
    fill: "#ff7350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m136 242v270c74.439 0 135-60.561 135-135s-60.561-135-135-135z",
    fill: "#ff4b20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m136 272c-57.897 0-105 47.103-105 105s47.103 105 105 105 105-47.103 105-105-47.103-105-105-105z",
    fill: "#e4f2f9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m136 272v210c57.897 0 105-47.103 105-105s-47.103-105-105-105z",
    fill: "#bde0f1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m176 362h-25v-45c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15h40c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#5f5f82"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m176 362h-25v-45c0-8.284-6.716-15-15-15v90h40c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#3c3c55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.287f02ad717dd4fcdbbd35e3444f2b38.svg";
export { ForwardRef as ReactComponent };